import { render, staticRenderFns } from "./ActivityForm.vue?vue&type=template&id=cd12a696&scoped=true"
import script from "./ActivityForm.vue?vue&type=script&lang=js"
export * from "./ActivityForm.vue?vue&type=script&lang=js"
import style0 from "./ActivityForm.vue?vue&type=style&index=0&id=cd12a696&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd12a696",
  null
  
)

export default component.exports